var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 51.4668L20.7763 32.3585C22.339 30.7962 24.4583 29.9186 26.668 29.9186C28.8777 29.9186 30.9969 30.7962 32.5596 32.3585L51.668 51.4668M43.3346 43.1335L49.943 36.5251C51.5057 34.9629 53.6249 34.0852 55.8346 34.0852C58.0443 34.0852 60.1636 34.9629 61.7263 36.5251L68.3346 43.1335M43.3346 18.1335H43.3763M10.0013 68.1335H60.0013C62.2114 68.1335 64.3311 67.2555 65.8939 65.6927C67.4567 64.1299 68.3346 62.0103 68.3346 59.8001V9.80013C68.3346 7.58999 67.4567 5.47038 65.8939 3.90757C64.3311 2.34477 62.2114 1.4668 60.0013 1.4668H10.0013C7.79117 1.4668 5.67155 2.34477 4.10875 3.90757C2.54594 5.47038 1.66797 7.58999 1.66797 9.80013V59.8001C1.66797 62.0103 2.54594 64.1299 4.10875 65.6927C5.67155 67.2555 7.79117 68.1335 10.0013 68.1335Z",
    stroke: "#D1D5DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUpload);
export default __webpack_public_path__ + "static/media/logo-upload.f8288e9ce2a23a5b15e992a1e0f05570.svg";
export { ForwardRef as ReactComponent };